import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Order, SalesOrdersService } from '@vendasta/sales-orders';
import moment from 'moment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sales-ui-sales-order-details-requested-activation',
  templateUrl: './sales-order-details-requested-activation.component.html',
  styleUrls: [
    './sales-order-details-requested-activation.component.scss',
    '../sales-order-details-card.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SalesOrderDetailsRequestedActivationComponent implements OnInit, OnChanges {
  @Input() order: Order;
  @Input() editable = false;

  isEditing = false;
  minDate = new Date();
  requestedActivation: Date;
  updatingRequestedActivation = false;

  constructor(
    private readonly salesOrdersService: SalesOrdersService,
    private readonly alertService: SnackbarService,
    private cdk: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.editable = changes.editable ? changes.editable.currentValue : this.editable;
    this.requestedActivation = changes.requestedActivation
      ? changes.requestedActivation.currentValue
      : this.requestedActivation;
  }

  ngOnInit(): void {
    this.requestedActivation = this.order.requestedActivation;
  }

  formatDate(date: Date): string {
    return moment(date).format('lll');
  }

  edit(): void {
    this.isEditing = true;
  }

  updateRequestedActivation(): void {
    this.isEditing = true;
    this.updatingRequestedActivation = true;

    if (this.requestedActivation === undefined || this.requestedActivation === null) {
      this.alertService.openErrorSnack('SALES_ORDERS.ERRORS.BAD_DATE_FORMAT');
      this.requestedActivation = this.order.requestedActivation;
      this.isEditing = false;
      this.updatingRequestedActivation = false;
      this.cdk.detectChanges();
      return;
    }

    // ensure the type is a Date so we can properly set hours on it
    const requestedActivation = new Date(this.requestedActivation);
    requestedActivation.setHours(7);
    this.salesOrdersService
      .updateRequestedActivation(this.order.orderId, this.order.businessId, requestedActivation)
      .pipe(take(1))
      .subscribe(
        () => {
          this.isEditing = false;
          this.updatingRequestedActivation = false;
          this.cdk.detectChanges();
        },
        () => {
          this.isEditing = false;
          this.updatingRequestedActivation = false;
          this.requestedActivation = this.order.requestedActivation;
          this.cdk.detectChanges();
          this.alertService.openErrorSnack('FRONTEND.SALES_UI.CONTRACT_START_ERROR');
        },
      );
  }
}
